import datapoints from '../datapoints';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { getFocusedFilterForTable, MailSortHelper, listViewStore, } from 'owa-mail-list-store';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
var selectSortInternal = action('selectSortInternal', datapoints.selectSort)(function selectSortInternal(sortColumnToSelect, sortDirectionToSelect, tableView, actionSource) {
    var sortBy = {
        sortColumn: sortColumnToSelect,
        sortDirection: sortDirectionToSelect,
    };
    var tableQuery = createMailFolderTableQuery(tableView.tableQuery.folderId, tableView.tableQuery.listViewType, tableView.tableQuery.scenarioType, getFocusedFilterForTable(tableView), 'All', null /* categoryName */, // Support sort - VSO: 23489 - Category Filter Drop down menu to show in category list view and category search
    sortBy // sortBy selected by the user
    );
    return loadTableViewFromTableQuery(tableQuery);
});
/**
 * Selects the sort on the current selected table
 * @param sortColumn selected by the user
 * @param tableViewId table view id
 * @param actionSource source of this action
 */
export default action('selectSort')(function selectSort(sortColumn, tableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var currentSortBy = tableView.tableQuery.sortBy;
    var isSameSortColumnSelected = currentSortBy.sortColumn == sortColumn;
    var sortDirectionToSelect;
    if (isSameSortColumnSelected) {
        // If same sort is selected then toggle the sort direction and load the table
        sortDirectionToSelect =
            currentSortBy.sortDirection == MailSortHelper.ASCENDING_SORT_DIR
                ? MailSortHelper.DESCENDING_SORT_DIR
                : MailSortHelper.ASCENDING_SORT_DIR;
    }
    else {
        // If different sort is selected then get the default sort direction for this sort column
        sortDirectionToSelect = MailSortHelper.getDefaulSortDirectionForSortColumn(sortColumn);
    }
    selectSortInternal(sortColumn, sortDirectionToSelect, tableView, actionSource);
    undoActions.clearLastUndoableAction();
});
//# sourceMappingURL=selectSort.js.map